/* Sale-Landing — Drawer-Toggle, Sort-Submit, Filter-Click-Routing,
   Größen-Sortierung (clientseitig).
   Keine Frameworks, vanilla. Wird als <script src="..."></script> geladen.
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ── Größen-Sortierung ────────────────────────────────────
  var KNIT_ORDER = { 'XS': -2, 'S': -1, 'M': 0, 'L': 1, 'XL': 2, 'XXL': 3, 'XXXL': 4 };

  function sortKey(label) {
    if (!label) return 9999;
    var s = String(label).trim();
    // "44 / 46" → first number
    if (s.indexOf(' / ') !== -1) s = s.split(' / ')[0].trim();
    // Range "44-47": first number
    if (s.indexOf('-') !== -1 && /^\d/.test(s)) s = s.split('-')[0].trim();
    // L-Suffix bei Hemden: "39L" → 39.5 (zwischen 39 und 40)
    var bonus = 0;
    if (/^\d+L$/i.test(s)) {
      bonus = 0.5;
      s = s.slice(0, -1);
    }
    // Komma → Punkt für Schuhgrößen
    s = s.replace(',', '.');
    // Buchstaben-Größen
    var upper = s.toUpperCase();
    if (KNIT_ORDER.hasOwnProperty(upper)) return KNIT_ORDER[upper];
    var n = parseFloat(s);
    if (isNaN(n)) return 9999;
    return n + bonus;
  }

  function getLabelText(node) {
    // Card-Strip: Span direkt
    if (node.classList.contains('sale-card__size')) return node.textContent.trim();
    // Sidebar-Item: erstes <span> innerhalb <label> (vor dem Count)
    var label = node.querySelector('label');
    if (label) {
      var spans = label.querySelectorAll('span');
      for (var i = 0; i < spans.length; i++) {
        if (!spans[i].classList.contains('sale-filter-list__count')) {
          return spans[i].textContent.trim();
        }
      }
    }
    return node.textContent.trim();
  }

  function isNumericish(items) {
    var hits = 0;
    for (var i = 0; i < items.length; i++) {
      var t = getLabelText(items[i]);
      if (/^\d|^[XSML]/i.test(t)) hits++;
    }
    return items.length > 0 && hits / items.length > 0.5;
  }

  function sortChildrenIfNumeric(parent) {
    var items = Array.from(parent.children);
    if (items.length < 2) return;
    if (!isNumericish(items)) return;
    items.sort(function (a, b) {
      return sortKey(getLabelText(a)) - sortKey(getLabelText(b));
    });
    items.forEach(function (i) { parent.appendChild(i); });
  }

  // ── Strick-Konsolidierung ─────────────────────────────────
  // Liquid rendert pro Bucket-Match ein <li> mit data-Attributen.
  // JS gruppiert nach (bucket, norm), summiert counts, baut konsolidierte Items
  // mit Multi-Value-URL-Click-Handler.
  // Gruppen-Ueberschriften je Sprache (Sprachweiche 13.10.2026); unbekannte Sprache faellt auf EN zurueck
  var BUCKET_LABELS = {
    de: { damen: "Damen", herren: "Herren", other: "Sonstige" },
    nl: { damen: "Dames", herren: "Heren", other: "Overig" },
    en: { damen: "Women", herren: "Men", other: "Other" },
    fr: { damen: "Femme", herren: "Homme", other: "Autres" },
    it: { damen: "Donna", herren: "Uomo", other: "Altre" },
    sv: { damen: "Dam", herren: "Herr", other: "Övriga" },
    pl: { damen: "Damskie", herren: "Męskie", other: "Inne" }
  };
  var BUCKET_LABEL = BUCKET_LABELS[document.documentElement.lang.toLowerCase().split('-')[0]] || BUCKET_LABELS.en;
  var BUCKET_ORDER = ['damen', 'herren', 'other'];

  function consolidateKnitList(list) {
    var rawItems = Array.from(list.querySelectorAll('[data-sale-bucket]'));
    if (!rawItems.length) return;

    var paramName = list.getAttribute('data-sale-param-name') || (rawItems[0] && rawItems[0].getAttribute('data-sale-param-name'));

    // Group: bucket → norm → array of {raw, count, active, add, remove}
    var groups = { damen: {}, herren: {}, other: {} };
    rawItems.forEach(function (i) {
      var bucket = i.getAttribute('data-sale-bucket');
      var norm = i.getAttribute('data-sale-norm');
      if (!groups[bucket]) groups[bucket] = {};
      if (!groups[bucket][norm]) groups[bucket][norm] = [];
      groups[bucket][norm].push({
        raw: i.getAttribute('data-sale-raw'),
        count: parseInt(i.getAttribute('data-sale-count') || '0', 10),
        active: i.getAttribute('data-sale-active') === 'true',
        add: i.getAttribute('data-sale-add'),
        remove: i.getAttribute('data-sale-remove')
      });
    });

    // Original-Items entfernen
    rawItems.forEach(function (i) { i.remove(); });

    BUCKET_ORDER.forEach(function (bucket) {
      var norms = Object.keys(groups[bucket]);
      if (!norms.length) return;
      norms.sort(function (a, b) { return sortKey(a) - sortKey(b); });

      var header = document.createElement('div');
      header.className = 'sale-filter-group__sub';
      header.textContent = BUCKET_LABEL[bucket];
      list.appendChild(header);

      var subList = document.createElement('ul');
      subList.className = 'sale-filter-list sale-filter-list--grid sale-filter-list--knit-sub';

      norms.forEach(function (norm) {
        var entries = groups[bucket][norm];
        var totalCount = entries.reduce(function (acc, e) { return acc + e.count; }, 0);
        var anyActive = entries.some(function (e) { return e.active; });
        var rawValues = entries.map(function (e) { return e.raw; });

        var li = document.createElement('li');
        li.className = 'sale-filter-list__item';

        var label = document.createElement('label');
        label.style.cursor = 'pointer';

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.checked = anyActive;
        input.setAttribute('data-sale-multi-toggle', 'true');
        input.setAttribute('data-sale-param', paramName);
        input.setAttribute('data-sale-raws', rawValues.map(encodeURIComponent).join('|'));

        var labelSpan = document.createElement('span');
        labelSpan.textContent = norm;

        var countSpan = document.createElement('span');
        countSpan.className = 'sale-filter-list__count';
        countSpan.textContent = '(' + totalCount + ')';

        label.appendChild(input);
        label.appendChild(labelSpan);
        label.appendChild(countSpan);
        li.appendChild(label);
        subList.appendChild(li);
      });

      list.appendChild(subList);
    });
  }

  // Multi-Value-Click-Handler — wird nach Toggle ausgelöst.
  //
  // Intent (hinzufügen vs. entfernen) wird aus dem URL-Zustand abgeleitet,
  // NICHT aus input.checked. Grund: Unisex-Strick-Größen (Tri-Format wie
  // "42 Damen / 46 Herren / 42 engl.") landen bewusst in beiden Buckets.
  // Dadurch teilen sich Zwillings-Checkboxen ("Damen 42" / "Herren 46")
  // einen Roh-Wert. Wählt man eine, erscheint die Zwillings-Checkbox per
  // anyActive ebenfalls angehakt. Mit input.checked als Intent-Quelle würde
  // ein Klick darauf in den Entfernen-Zweig laufen und den geteilten Wert
  // herausreißen — die erste Auswahl ginge verloren (Bug: "zweite Größe
  // wählt die erste ab"). Über "alle Roh-Werte schon in der URL?" als
  // Intent-Quelle ergänzt ein Klick stattdessen die fehlenden Werte.
  function handleMultiToggle(input) {
    var paramName = input.getAttribute('data-sale-param');
    var rawsBlob = input.getAttribute('data-sale-raws');
    if (!paramName || !rawsBlob) return;

    var rawValues = rawsBlob.split('|').map(decodeURIComponent);

    var url = new URL(window.location.href);
    var existing = url.searchParams.getAll(paramName);

    // Voll ausgewählt = alle Roh-Werte dieser Checkbox stehen schon in der URL.
    var fullySelected = rawValues.every(function (v) {
      return existing.indexOf(v) !== -1;
    });

    url.searchParams.delete(paramName);

    if (!fullySelected) {
      // Hinzufügen: bestehende behalten, fehlende Roh-Werte ergänzen.
      existing.forEach(function (v) { url.searchParams.append(paramName, v); });
      rawValues.forEach(function (v) {
        if (existing.indexOf(v) === -1) url.searchParams.append(paramName, v);
      });
    } else {
      // Entfernen: bestehende minus die Roh-Werte dieser Checkbox.
      existing
        .filter(function (v) { return rawValues.indexOf(v) === -1; })
        .forEach(function (v) { url.searchParams.append(paramName, v); });
    }

    url.searchParams.set('page', '1');
    window.location.href = url.toString();
  }

  // Dedup: bei Konflikt im normalisierten Display-Label fallen alle
  // konfligierenden Items auf den Roh-String zurück, damit sie unterscheidbar
  // bleiben.
  function dedupeNormalizedLabels(parent) {
    var spans = parent.querySelectorAll('[data-sale-norm]');
    if (!spans.length) return;
    var counts = {};
    spans.forEach(function (s) {
      var n = s.getAttribute('data-sale-norm');
      counts[n] = (counts[n] || 0) + 1;
    });
    spans.forEach(function (s) {
      var n = s.getAttribute('data-sale-norm');
      if (counts[n] > 1) {
        s.textContent = s.getAttribute('data-sale-raw');
      }
    });
  }

  ready(function () {
    var drawer = document.getElementById('sale-drawer');

    // Strick-Konsolidierung: gruppieren + Multi-Value-Items aufbauen
    document.querySelectorAll('[data-sale-knit-list]').forEach(consolidateKnitList);

    // Multi-Toggle Click — feuert NACH Browser-Toggle der Checkbox
    document.addEventListener('change', function (e) {
      var multiInput = e.target.closest('[data-sale-multi-toggle]');
      if (!multiInput) return;
      e.stopPropagation();
      handleMultiToggle(multiInput);
    });

    // Dedup vor Sortierung, sonst sortiert man Display-Labels die sich noch ändern
    document.querySelectorAll('[data-sale-dedupe]').forEach(dedupeNormalizedLabels);

    // Größen sortieren auf Cards + in Sidebar/Drawer (nicht in Strick-Sub-Listen,
    // die werden vom Konsolidator schon sortiert)
    document.querySelectorAll('.sale-card__sizes').forEach(sortChildrenIfNumeric);
    document.querySelectorAll('.sale-filter-list:not([data-sale-knit-list]):not(.sale-filter-list--knit-sub)').forEach(sortChildrenIfNumeric);

    document.addEventListener('click', function (e) {
      var openTrigger = e.target.closest('[data-sale-drawer-open]');
      if (openTrigger && drawer) {
        e.preventDefault();
        drawer.hidden = false;
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        return;
      }

      var closeTrigger = e.target.closest('[data-sale-drawer-close]');
      if (closeTrigger && drawer) {
        e.preventDefault();
        drawer.classList.remove('is-open');
        drawer.hidden = true;
        document.body.style.overflow = '';
        return;
      }

      var filterLink = e.target.closest('[data-sale-filter-link]');
      if (filterLink) {
        var url = filterLink.getAttribute('data-sale-filter-link');
        if (url) {
          e.preventDefault();
          window.location.href = url;
        }
      }
    });

    document.addEventListener('change', function (e) {
      var sortSelect = e.target.closest('[data-sale-sort]');
      if (!sortSelect) return;

      var sortValue = sortSelect.value;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      url.searchParams.set('page', '1');
      window.location.href = url.toString();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        drawer.hidden = true;
        document.body.style.overflow = '';
      }
    });
  });
})();
